import { Paper, Typography, Stack, Box } from "@mui/material";
import { InventoryEstimate } from "src/store/api/generatedApi";
import { ValidatedTextField } from "components/common/inputs/validatedTextField";
import { useTenantTranslation, useUnitsFormatter } from "hooks/formatters";
import { InventoryMeasurementSubmitButton } from "./InventoryMeasurementSubmitButton";
import { useInventoryNumberSerialiser } from "../hooks";
import { useInventoryMeasurement } from "./InventoryMeasurementProvider";
import { InventoryMeasurementFormState } from "../types";

export interface InventoryMeasurementFormMobileProps {
  inventoryEstimate: InventoryEstimate;
}

export const InventoryMeasurementFormMobile = ({
  inventoryEstimate,
}: InventoryMeasurementFormMobileProps) => {
  const { t } = useTenantTranslation();
  const unitsFormatter = useUnitsFormatter(false);
  const {
    inventoryMeasurementFormData,
    adjustQuantity,
    inventoryMeasurementFormState,
  } = useInventoryMeasurement();

  const numberSerialiser = useInventoryNumberSerialiser();

  return (
    <Stack spacing={2}>
      {inventoryEstimate.items
        .filter((item) => item.specific_price !== null)
        .map((item) => {
          const adjustedQuantity = inventoryMeasurementFormData.items.find(
            (i) => i.material_name === item.material_name
          )?.adjusted_quantity;

          return (
            <Paper
              key={item.material_name}
              sx={{ p: 2, border: 1, borderColor: "grey.300" }}
              elevation={0}
            >
              <Typography variant="subtitle1" gutterBottom>
                {item.material_name}
              </Typography>
              <Typography color="text.secondary" display="block" sx={{ mb: 1 }}>
                {t("current")}: {numberSerialiser.format(item.quantity)}
                {unitsFormatter("mass")}{" "}
                {`(${numberSerialiser.format(
                  item.specific_price
                )} ${unitsFormatter("specific_cost")})`}
              </Typography>
              <ValidatedTextField
                disabled={
                  inventoryMeasurementFormState ===
                  InventoryMeasurementFormState.Submitting
                }
                label={`${t("actualMass")} (${unitsFormatter("mass")} )`}
                value={adjustedQuantity}
                setValue={(val) => {
                  adjustQuantity(item.material_name, val);
                }}
                serialiser={numberSerialiser}
                textFieldProps={{ fullWidth: true }}
              />
            </Paper>
          );
        })}
      <Box sx={{ textAlign: "center" }}>
        <InventoryMeasurementSubmitButton />
      </Box>
    </Stack>
  );
};
